import * as BECaller from '../../util/apiCaller';

export const LOADING = 'NOTIFICATIONS_LOADING';
export const SUCCESS = 'NOTIFICATIONS_SUCCESS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data: data
  };
}

export function getNotifications() {
  return (dispatch) => {
    dispatch(isLoading(true));
    BECaller.api('account/notifications', 'get')
      .then(data => {
        if (data.list && data.list.length) {
          dispatch(success(data));
        } else {
          dispatch(success({list:[]}));
        }
      })
      .catch(err => {
        console.warn(err);
      });
  };
}
